<template>
  <modal
    :name="modalName.model"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
  >
    <card>
      <list
        :columns="model.columns"
        :modalCreate="model.modalCreate"
        :removeLink="model.removeLink"
        :cardLink="model.cardLink"
        :isUpdate="model.isUpdate"
        :isAdd="model.isAdd"
        :itemLink="model.itemLink"
        :setLink="model.setLink"
        :fields="model.fields"
        :searchDisable="model.searchDisable"
        @change="change"
      />
      <div class="text-center mb-2 mt-2">
        <p-button
          v-if="!isAccept"
          class="mx-1 btn-sm"
          type="info"
          @click.native.prevent="acceptRelate"
          >Применить</p-button
        >
        <p-button
          v-if="isAccept===true"
          class="mx-1 btn-sm"
          type="info"
         @click.native.prevent="acceptList"
          >Установить!</p-button
        >

        

        <p-button
          class="mx-1 btn-sm"
          type="warning"
          round
          @click.native.prevent="closeModal"
          >Отмена</p-button
        >
      </div>
    </card>
  </modal>
</template>
<script>

import { errorNotify } from "../../plugins/functions";
import { mapState } from "vuex";

export default {
  data() {
    return {
      value: null,
    };
  },
  props: {
    modalName: {
      default: "",
    },
    route: {
      default: "",
    },
     isAccept:{
      default:false
    },
  },
  components: {
  "list": () => import("@/components/List"),
  },
  computed: {
    ...mapState(["modals", "valueSelected"]),
    model() {
      return this.modals[this.modalName.model];
    },
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.modalName.model);
      this.$store.dispatch("openModal", null);
      this.$store.dispatch("selectValue", null);
    },
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
    acceptRelate() {
      this.$loading(true);
      this.$http
        .put(this.modalName.route, {
          model: this.value,
          relate: this.valueSelected,
        })
        .then((response) => {
          this.closeModal();
        })
        .catch((error) => {
          errorNotify(error, this);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });

      this.$store.dispatch("setLastUpdate", new Date());
    },
    acceptList() {
         this.$modal.hide(this.modalName.model);
         this.$emit('input',this.value);
    },
  },
};
</script>